import Retool from 'react-retool';
import { useLocation } from 'react-router';

import { RETOOL_COMMON_PROPS, RETOOL_URLS } from '@/config/retool';

const RETOOL_URL_MAP: Record<string, string> = {
  '/firm/workflows/processes': RETOOL_URLS.workflows.processes,
  '/firm/workflows/timeline': RETOOL_URLS.workflows.timeline,
  '/firm/workflows/todo': RETOOL_URLS.workflows.todo
};

const Workflows = () => {
  const location = useLocation();
  const retoolUrl =
    RETOOL_URL_MAP[location.pathname] || RETOOL_URLS.workflows.todo;

  const retoolData = {
    isEmbedded: true
  };

  return (
    <div className="h-full w-full bg-white dark:bg-gray-900">
      <Retool
        data={retoolData}
        url={retoolUrl}
        {...RETOOL_COMMON_PROPS}
      />
    </div>
  );
};

export default Workflows;
